var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { getMonitor } from '../../mock/health';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '../../store';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
const components = {
    Line
};
const borderColor = 'rgb(28, 176, 177)';
const backgroundColor = 'rgba(28, 176, 177, 0.6)';
const LineChart = ({ type, title }) => {
    _react_refresh_temp_2();
    const options = {
        responsive: true,
        plugins: {
            legend: { position: 'top' },
            title: { display: true, text: title }
        }
    };
    const isActiveMonitorPanelSelector = createSelector((state) => state.healthMonitor, (healthMonitor) => healthMonitor.isOpen);
    const isActiveHealthMonitorPanel = useAppSelector(isActiveMonitorPanelSelector);
    const generateDatasetObject = (label, data = []) => {
        return { label, data, borderColor, backgroundColor };
    };
    const TIME_INTERVAL = 2000;
    const [IoMTDataset] = useState([]);
    const [labels] = useState([]);
    const [dataset, setDataset] = useState({
        labels: [],
        datasets: [generateDatasetObject(title)]
    });
    useEffect(() => {
        let interval;
        // active fetch only if modal is open
        if (isActiveHealthMonitorPanel) {
            interval = setInterval(() => {
                var _a;
                const realTimeMonitor = getMonitor(title);
                const IoMTDeviceInput = (_a = realTimeMonitor === null || realTimeMonitor === void 0 ? void 0 : realTimeMonitor.value) !== null && _a !== void 0 ? _a : 0;
                IoMTDataset.push(IoMTDeviceInput);
                labels.push(Date.now().toString());
                const datasets = {
                    datasets: [generateDatasetObject(title, IoMTDataset)]
                };
                const newDataset = {
                    labels: labels,
                    ...datasets
                };
                setDataset(dataset => ({ ...dataset, ...newDataset }));
            }, TIME_INTERVAL);
        }
        return () => clearInterval(interval);
    }, [isActiveHealthMonitorPanel]);
    return _jsx("div", { className: 'monitor-chart-wrapper', children: React.createElement(components[type], {
            options: options,
            data: dataset
        }) });
};
_react_refresh_temp_1 = LineChart;
$RefreshReg$(_react_refresh_temp_1, "LineChart");
_react_refresh_temp_2(LineChart, "4wDgWB5L/yYaWwff2RejF6DYh0w=", false, () => [useAppSelector]);
export default LineChart;
